import React, { useRef, useState, useEffect } from 'react';
//
import { useSelector, useDispatch } from 'react-redux';
// ANTD
import { Upload, message, Empty, Tooltip, Button } from 'antd';
import { DeleteFilled } from '@ant-design/icons';
// GALLERY
import ImageGallery from 'react-image-gallery';
import 'react-image-gallery/styles/css/image-gallery.css';
// IMAGE
import bgUploadImage from 'static/img/fullTourView/default-profile-image.jpg';
//
import { PlaceUpdateImage } from 'actions/Place/place.action';
// API
import { placeAPI } from 'app/API/place.service.api';
import withTranslations from 'app/components/HOGs/withTranslations';
import ModalPreviewPictures from 'app/components/Utility/modalPreviewPicture';
import { fixHttps } from 'app/components/Utility/coreFunctions';

// CONST
const { Dragger } = Upload;

const getFileId = (img) => {
  if (img.id) {
    return img.id;
  } else if (
    img &&
    img.response &&
    img.response.body &&
    img.response.body.id > 0
  ) {
    return img.response.body.id;
  } else {
    return '';
  }
};

// IMAGE UPLOAD

const addFileId = (ids, file) => {
  let id = getFileId(file).toString();
  if (ids) {
    id += `,${ids}`;
  }
  return id;
};

const uploadImage = (props, file) => {
  const { activeMultiPart, dispatch } = props;
  const placeData = { ...activeMultiPart };
  placeData.images.unshift(file);
  placeData.imgids = addFileId(placeData.imgids, file);
  dispatch(
    PlaceUpdateImage({
      images: placeData.images,
      imgids: placeData.imgids,
    })
  );
};

const deleteImage = (img, props) => {
  console.log(img);
  const { activeMultiPart, dispatch } = props;
  const placeData = { ...activeMultiPart };
  console.log(placeData.images);
  const id = getFileId(img);
  console.log(id);
  const ids = placeData.imgids.split(',');
  const idIndex = ids.indexOf(id);
  ids.splice(idIndex, 1);
  placeData.imgids = ids.join();
  const index = placeData.images.indexOf(img);
  placeData.images.splice(index, 1);
  console.log(placeData.images);
  dispatch(
    PlaceUpdateImage({
      images: placeData.images,
      imgids: placeData.imgids,
    })
  );
};

const CarouselBig = (props) => {
  const carouselRef = useRef();
  const {
    tr,
    dispatch,
    activeTourTab = 0,
    full,
    setFull,
    activeMultiPart,
    isEditMode,
    fetched,
  } = props;

  useEffect(() => {
    if (!full && carouselRef.current) {
      carouselRef.current.exitFullScreen();
    }
  }, [full]);

  const images = [];
  if (fetched === true) {
    const { images: partImages } = activeMultiPart;
    const dataImage = partImages || [];

    dataImage.map((img) => {
      const obj = {
        original: img.fullpath
          ? fixHttps(img.fullpath)
          : fixHttps(img.thumbUrl),
        thumbnail: img.path ? fixHttps(img.path) : fixHttps(img.thumbUrl),
      };
      if (img.fullpath) {
        obj.src = fixHttps(img.fullpath);
      } else if (img.response && img.response.body) {
        obj.original = fixHttps(img.response.body.original);
      } else if (img.thumbUrl) {
        obj.thumbUrl = fixHttps(img.thumbUrl);
      }
      images.push(obj);

      return null;
    });

    const component =
      dataImage.length > 0 ? (
        <div style={{ width: '100%', height: '100%' }}>
          <Tooltip title={tr.Delete}>
            {isEditMode ? (
              <Button
                size="small"
                type="primary"
                ghost
                shape="circle"
                className="deletePicturesBtn"
                onClick={() => {
                  const index = carouselRef.current.getCurrentIndex();

                  if (index === dataImage.length - 1) {
                    carouselRef.current.slideToIndex(0);
                  }

                  deleteImage(
                    dataImage[carouselRef.current.getCurrentIndex()],
                    { activeMultiPart, dispatch }
                  );
                }}
                style={{ position: 'absolute', zIndex: 1, right: 5, top: 5 }}
              >
                <DeleteFilled
                  style={{
                    fontSize: 14,
                  }}
                />
              </Button>
            ) : null}
          </Tooltip>
          <ImageGallery
            ref={carouselRef}
            key={activeTourTab}
            items={images}
            showNav
            showThumbnails={dataImage.length > 1}
            showFullscreenButton={!isEditMode}
            showPlayButton={false}
            originalClass="galleryImg"
            thumbnailClass="gallerythumbnailImg"
            additionalClass=""
            useBrowserFullscreen={false}
            slideDuration={0}
            slideInterval={0}
            onScreenChange={(el) => setFull(el)}
          />
          <ModalPreviewPictures
            visible={full}
            setVisible={setFull}
            picture=""
            picturesData={images}
            index={full ? carouselRef.current.getCurrentIndex() : 0}
          />
        </div>
      ) : (
        <div
          style={{
            width: '100%',
            height: '100%',
            display: 'flex',
            alignItems: 'center',
            opacity: 0.5,
          }}
        >
          {isEditMode ? (
            <img
              src={bgUploadImage}
              alt="defaulBgUploadImage"
              style={{ height: 170, position: 'relative', right: 100 }}
            />
          ) : (
            <Empty description="No Image" />
          )}
        </div>
      );
    return component;
  }
  return '';
};

//

const PlaceImageGallery = (props) => {
  const { tr } = props;
  const dispatch = useDispatch();
  const publicTypeRequiredFiled = useSelector(
    (store) => store.placesData.publicTypeRequiredFiled
  );
  const activeMultiPart = useSelector((store) => store.placesData.data);
  const isEditMode = useSelector((store) => store.placesData.isEditMode);
  const fetched = useSelector((store) => store.placesData.fetched);

  const [full, setFull] = useState(false);
  const isPicturesExists = () =>
    activeMultiPart.images && activeMultiPart.images.length;

  const getClass = () =>
    isPicturesExists() ? 'uploadLayout existPictures' : 'uploadLayout';

  return (
    <div
      className={props.edit ? 'pictureLayout edit' : 'pictureLayout'}
      style={
        !publicTypeRequiredFiled.img
          ? { border: '1px solid red' }
          : { border: '1px solid transparent' }
      }
    >
      <CarouselBig
        tr={tr}
        fetched={fetched}
        full={full}
        setFull={setFull}
        activeMultiPart={activeMultiPart}
        dispatch={dispatch}
        isEditMode={isEditMode}
      />
      {isEditMode ? (
        <div
          className={getClass()}
          onClickCapture={(event) => {
            if (
              isPicturesExists() &&
              event.target.className &&
              event.target.className !== 'ant-upload-drag-picture'
            ) {
              event.stopPropagation();
              event.preventDefault();
              setFull(true);
            }
          }}
        >
          <Dragger
            name="file"
            listType="picture-card"
            multiple
            showUploadList={{ showPreviewIcon: false, showRemoveIcon: true }}
            action={placeAPI.getUploadPictureURL()}
            onChange={(info) => {
              const { status } = info.file;
              if (status === 'done') {
                uploadImage({ activeMultiPart, dispatch }, info.file);
                message.success(
                  `${info.file.name} ${tr['file uploaded successfully']}`
                );
              } else if (status === 'error') {
                message.error(`${info.file.name} ${tr['file upload failed']}`);
              }
            }}
          >
            <div className="ant-upload-drag-text">
              {tr['Click or drag file to this area to upload']}
            </div>
            <div className="ant-upload-drag-picture" />
          </Dragger>
        </div>
      ) : null}
    </div>
  );

  // return (
  //   <div className="pictureLayout">
  //     <CarouselBig {...props} />
  //     {props.edit ? (
  //       <div className="uploadLayout">
  //         <Dragger
  //           name="file"
  //           listType="picture-card"
  //           multiple
  //           showUploadList={{ showPreviewIcon: false, showRemoveIcon: true }}
  //           action={placeAPI.getUploadPictureURL()}
  //           onChange={(info) => {
  //             const { status } = info.file;
  //             if (status === 'done') {
  //               uploadImage(props, info.file);
  //               message.success(
  //                 `${info.file.name} ${tr['file uploaded successfully']}`
  //               );
  //             } else if (status === 'error') {
  //               message.error(`${info.file.name} ${tr['file upload failed']}`);
  //             }
  //           }}
  //         >
  //           <div className="ant-upload-drag-text">
  //             {tr['Click or drag file to this area to upload']}
  //           </div>
  //           <div className="ant-upload-drag-picture" />
  //         </Dragger>
  //       </div>
  //     ) : null}
  //   </div>
  // );
};

export default withTranslations(PlaceImageGallery);
